import Aggregation from '../../../../types/report/Aggregation';
import DataSourceField from '../../../../types/report/DataSourceField';
import DeclarationHelper from '../../../types/Functions/DeclarationHelper';
import ReportConfig from '../../../../types/report/ReportConfig';
import ReportLogicLocation from '../../../../types/functions/Location/ReportLogicLocation';
import locationType from '../../../../types/functions/Location/LocationType';

class AggregatedRecordFieldHelper implements DeclarationHelper<DataSourceField> {

    add(declarations: DataSourceField[], declaration: DataSourceField): void {

        declarations.push(declaration);
    }

    remove(declarations: DataSourceField[], location: ReportLogicLocation): DataSourceField[] {

        if (location.subType === locationType.statement.aggregatedRawField) {
            return declarations.filter(x => x.fieldId !== location.fieldId);
        }

        if (location.subType === locationType.statement.aggregatedVariable) {
            return declarations.filter(x => x.variableNumber !== location.fieldId);
        }

        throw new Error('Not supported subtype');
    }

    getDeclarations(config: ReportConfig, location: ReportLogicLocation): DataSourceField[] {

        let aggregation = this.getAggregation(config, location);

        return aggregation.fields;
    }

    getDeclaration(declarations: DataSourceField[], location: ReportLogicLocation): DataSourceField {

        if (location.subType === locationType.statement.aggregatedRawField) {
            return declarations.find(x => x.fieldId === location.fieldId) as DataSourceField;
        }

        if (location.subType === locationType.statement.aggregatedVariable) {
            return declarations.find(x => x.variableNumber === location.fieldId) as DataSourceField;
        }

        throw new Error('Not supported subtype');
    }

    getDataSourceId(config: ReportConfig, location: ReportLogicLocation): number {

        let aggregation = this.getAggregation(config, location);

        return aggregation?.dataSourceId || 0;
    }

    getEmpty(_: number | null): DataSourceField {

        return {} as DataSourceField;
    }

    private getAggregation(config: ReportConfig, location: ReportLogicLocation): Aggregation {

        return config.aggregations.find(x => x.number === location.statementNumber) as Aggregation;
    }
}

const aggregatedRecordFieldHelper = new AggregatedRecordFieldHelper();

const findAggregatedRecordField = (config: ReportConfig, location: ReportLogicLocation): DataSourceField | undefined => {

    let fields = config.aggregations?.find(x => x.number === location.statementNumber)?.fields || [];

    if (location.subType === locationType.statement.aggregatedVariable) {
        return fields.find(x => x.variableNumber === location.fieldId);
    }

    return fields.find(x => x.fieldId === location.fieldId);
};

export { findAggregatedRecordField };

export default aggregatedRecordFieldHelper;
